import {Component, Input} from '@angular/core';
import {ModalsService} from "../../services/modals.service";
import {RulesService} from "../../services/rules.service";
import {Contact} from "../../model/contact";

@Component({
  selector: 'app-delete-contact-modal',
  templateUrl: './delete-contact-modal.component.html',
  styleUrls: ['./delete-contact-modal.component.css']
})
export class DeleteContactModalComponent {
  @Input() contact: Contact;

  requestInProgress: boolean;
  removed: boolean;

  constructor(private readonly modalsService: ModalsService,
              private readonly rulesService: RulesService) {
    this.requestInProgress = false;
    this.removed = false;
  }

  close(): void {
    this.modalsService.hideModal();
  }

  delete(): void {
    if (!this.requestInProgress) {
      this.requestInProgress = true;
      this.rulesService.deleteContact(this.contact.id)
        .subscribe(code => {
          if (code == 200) {
            this.removed = true;
          }
          this.rulesService.loadContacts();
          this.requestInProgress = false;
        });
    }
  }
}
